import { createStoresContext } from "./create-context";
import { ActionModalsStore } from "./ActionModalsStore";
import { ContractList } from "./ContractList";
import { BidList } from "./BidList";
import { ContractCardStore } from "./ContractInfoStore";
import { UserStore } from "./UserStore";
import { api } from "services";
import { BidCardStore } from "./BidInfoStore";
import { QuoteList } from "./QuotesList";
import { CompanyCardStore } from "./CompanyCardStore";
import { CompanyList } from "./CompanyList";
import { UserListStore } from "./UserListStore";
import { UserCardStore } from "./UserCardStore";
import { SettingsStore } from "./SettingsStore";
import { ContractBidsList } from "./ContractBidsList";
import { CompanyContractList } from "./CompanyContractList";
import { CompanyUserList } from "./CompanyUserList";
import { ProfileStore } from "./ProfileStore";
import { BankAccountsStore } from "./bankAccountsStore";
import { BankAccountsDetailStore } from "./bankAccountsDetailStore";
import { PendingActionsBidList } from "./PendingActionsBidList";
import { PendingActionsContractList } from "./PendingActionsContractList";
import { PendingActionsCompanyList } from "./PendingActionsCompanyList";
import { BidListWithBalance } from "./BidListWithBalance";
import { PendingStatisticsStore } from "./PendingStatistics";
import { UserCompanyList } from "./UserCompanyList";
import { AmlCheckList } from "./AmlCheckList";
import { CheckLimitStore } from "./CheckLimitStore";
import { NotificationStore } from "./NotificationStore";
import { BidTransactionList } from "./BidTransactionList";
import { BidWalletCheckList } from "./BidWalletCheckList";
import { FiatCurrencyList } from "./FiatCurrencyList";
import { BidHistory } from "./BidHistory";
import { Templates } from "./Templates";
import { NominalAccountsStore } from "./NominalAccountsStore";
import { RubWithdrawalRequestsList } from "./RubWithdrawalRequestsList";
import { RubOperationList } from "./RubOperationList";
import { WebSettingsStore } from "./WebSettings";
import { OfferDoc } from "./OfferDoc";
import { HintsManagementStore } from "./HintsManagementStore";
import { BankStatementStore } from "./BankStatementsStore";
import { WalletsWhitelistStore } from "./WalletsWhitelistStore";

export interface IStores {
  actionModals: ActionModalsStore;
  contracts: ContractList;
  bids: BidList;
  contractCard: ContractCardStore;
  bidCard: BidCardStore;
  user: UserStore;
  quotes: QuoteList;
  companyCard: CompanyCardStore;
  settings: SettingsStore;
  companies: CompanyList;
  userList: UserListStore;
  userCard: UserCardStore;
  profile: ProfileStore;
  contractBids: ContractBidsList;
  companyContracts: CompanyContractList;
  companyUsers: CompanyUserList;
  bankAccountsStore: BankAccountsStore;
  bankAccountsDetailStore: BankAccountsDetailStore;
  pendingActionsBidList: PendingActionsBidList;
  bidsWithBalance: BidListWithBalance;
  pendingActionsContractList: PendingActionsContractList;
  pendingActionsCompanyList: PendingActionsCompanyList;
  pendingStatistics: PendingStatisticsStore;
  userCompanyList: UserCompanyList;
  amlCheckList: AmlCheckList;
  checkLimit: CheckLimitStore;
  bidTransactions: BidTransactionList;
  notificationSettings: NotificationStore;
  bidWalletChecks: BidWalletCheckList;
  fiatCurrencyList: FiatCurrencyList;
  bidHistory: BidHistory;
  templates: Templates;
  offerDoc: OfferDoc;
  nominalAccounts: NominalAccountsStore;
  rubWithdrawalRequests: RubWithdrawalRequestsList;
  rubOperations: RubOperationList;
  webSettings: WebSettingsStore;
  hintsManagement: HintsManagementStore;
  bankStatements: BankStatementStore;
  walletsWhitelist: WalletsWhitelistStore;
}

const stores: IStores = {} as any;

stores.user = new UserStore(
  {
    userService: {
      login: api.login,
      logout: api.logout,
      refreshToken: api.refreshToken,
      dropToken: api.dropToken,
      error: null,
    },
  },
  stores
);

stores.actionModals = new ActionModalsStore();
stores.contracts = new ContractList(stores);
stores.bids = new BidList(stores);
stores.contractCard = new ContractCardStore();
stores.bidCard = new BidCardStore();
stores.quotes = new QuoteList(stores);
stores.companyCard = new CompanyCardStore();
stores.settings = new SettingsStore();
stores.companies = new CompanyList(stores);
stores.userList = new UserListStore(stores);
stores.userCard = new UserCardStore();
stores.profile = new ProfileStore();
stores.contractBids = new ContractBidsList(stores);
stores.companyContracts = new CompanyContractList(stores);
stores.companyUsers = new CompanyUserList(stores);
stores.bankAccountsStore = new BankAccountsStore();
stores.bankAccountsDetailStore = new BankAccountsDetailStore();
stores.pendingActionsBidList = new PendingActionsBidList(stores);
stores.pendingActionsContractList = new PendingActionsContractList(stores);
stores.pendingActionsCompanyList = new PendingActionsCompanyList(stores);
stores.bidsWithBalance = new BidListWithBalance(stores);
stores.pendingStatistics = new PendingStatisticsStore();
stores.userCompanyList = new UserCompanyList(stores);
stores.amlCheckList = new AmlCheckList(stores);
stores.checkLimit = new CheckLimitStore();
stores.bidTransactions = new BidTransactionList(stores);
stores.notificationSettings = new NotificationStore();
stores.bidWalletChecks = new BidWalletCheckList(stores);
stores.fiatCurrencyList = new FiatCurrencyList(stores);
stores.bidHistory = new BidHistory(stores.bidCard);
stores.templates = new Templates();
stores.rubWithdrawalRequests = new RubWithdrawalRequestsList(stores);
stores.rubOperations = new RubOperationList(stores);
stores.webSettings = new WebSettingsStore();
stores.offerDoc = new OfferDoc();
stores.hintsManagement = new HintsManagementStore(stores);
stores.bankStatements = new BankStatementStore(stores);
stores.walletsWhitelist = new WalletsWhitelistStore(stores);
stores.nominalAccounts = new NominalAccountsStore(stores);

const { StoresProvider, useStores } = createStoresContext<typeof stores>();
export { StoresProvider, useStores };

//@ts-ignore
window.stores = stores;

export default stores;
